<app-banner></app-banner>
<app-categories></app-categories>
<app-gallery></app-gallery>
<app-why-us></app-why-us>
<app-testimonials></app-testimonials>
<app-contact></app-contact>
